import { createComponent } from '@carvana/merch-components';

export const Wrapper = createComponent('div', {
  className: 'hidden w-full grid-cols-4 m:grid'
});

export const ItemWrapper = createComponent('div', {
  className: 'flex w-full items-center gap-16 p-16'
});

export const ImageWrapper = createComponent('div', {
  className: 'flex h-32 w-32 items-center'
});

export const Label = createComponent('div', {
  className: 'text-blue-6 tl-body-m'
});
